<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else>
      <v-layout wrap>
        <v-flex class="screen-title mb-0" xs12>
          <span>{{ adminText('workflowsAll.halls_bd734aa', 'Halls') }}</span>
        </v-flex>
        <div class="mb-32 title-description">
          {{ adminText('workflowsAll.create_and_edit_halls_for_your_event_287fa4f', 'Create and edit halls for your event.') }}
        </div>
        <v-flex class="pb-16" xs12>
          <main-button depressed @click="goTo(routes.organizer.newHall)">
            {{ adminText('workflowsAll.create_hall_f8c55d6', 'Create hall') }}
          </main-button>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="workflowUi(halls)"
            item-clickable
            :headers="workflowUi([{ text: adminText('workflowsAll.name_709a232', 'Name'), align: 'left', value: 'name' }])"
            @item-click="
              goTo(routes.organizer.updateHall, {
                eventId: eventId,
                hallId: $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_EVENT_HALLS } from '../../graphql/halls.graphql.js'
import { apolloClient } from '../../apollo'

export default {
  mixins: [WorkflowDisplay],
  name: 'halls-list-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      halls: [],
    }
  },
  apollo: {
    getEventHalls: {
      query: GET_EVENT_HALLS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          this.halls = data.getHalls
        }
      },
    },
  },
}
</script>

<style></style>
